(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.updateHeaderVisualState();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    updateHeaderVisualState(scrollTop = window.pageYOffset || document.documentElement.scrollTop) {
      if (!this.classList.contains('header-wrapper')) return;

      const isHome = document.body.classList.contains('template-index');
      const threshold = 40;

      this.classList.remove('mb-is-top', 'mb-is-scrolled');

      if (isHome && scrollTop <= threshold) {
        this.classList.add('mb-is-top');
      } else {
        this.classList.add('mb-is-scrolled');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.updateHeaderVisualState(scrollTop);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobelli-social-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mobelli-social-proof')) {
    customElements.define('mobelli-social-proof', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        // Wait for children when the browser parses an already-registered element.
        this.frame = requestAnimationFrame(() => {
          this.track = this.querySelector('.msp__track');
          if (!this.track) return;
          this.classList.add('is-enhanced');
          this.addEventListener('click', event => {
            const read = event.target.closest('.msp__read');
            if (read) {
              const review = read.parentElement.querySelector('.msp__review');
              const expanded = review.classList.toggle('is-expanded');
              read.setAttribute('aria-expanded', String(expanded));
              read.textContent = expanded ? this.dataset.less : this.dataset.more;
            }
            const arrow = event.target.closest('[data-direction]');
            if (arrow && !arrow.disabled) this.move(Number(arrow.dataset.direction));
          }, { signal });
          this.track.addEventListener('scroll', () => this.updateArrows(), { signal, passive:true });
          this.track.addEventListener('keydown', event => {
            if (event.target !== this.track) return;
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
              event.preventDefault();
              this.move(event.key === 'ArrowRight' ? 1 : -1);
            }
          }, { signal });
          document.addEventListener('shopify:block:select', event => {
            const card = Array.from(this.querySelectorAll('.msp__card')).find(item => item.dataset.blockId === event.detail?.blockId);
            if (card) this.track.scrollTo({ left:card.offsetLeft - this.track.offsetLeft - (parseFloat(getComputedStyle(this.track).paddingLeft) || 0), behavior:'instant' });
          }, { signal });
          this.observer = new ResizeObserver(() => this.measure());
          this.observer.observe(this.track);
          this.measure();
          if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }
      move(direction) {
        const card = this.querySelector('.msp__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({ left:direction * (card.getBoundingClientRect().width + gap), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      measure() {
        this.querySelectorAll('.msp__card').forEach(card => {
          const review = card.querySelector('.msp__review');
          const button = card.querySelector('.msp__read');
          if (review.classList.contains('is-expanded')) { button.hidden = false; return; }
          button.hidden = review.scrollHeight <= review.clientHeight + 1;
        });
        this.updateArrows();
      }
      updateArrows() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.querySelectorAll('[data-direction]').forEach(button => {
          button.hidden = max < 2;
          button.disabled = Number(button.dataset.direction) < 0 ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= max - 2;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
